import styled from 'styled-components'
import { ReactNode } from 'react'
import Form from '@/ui/Form'
import ErrorLabel from './ErrorLabel'

interface InputWithSelectProps {
  error: string
  input: any
  label: ReactNode
  labelText?: string | null
  defaultValue?: string
  select?: any
  style?: any
  touched: boolean
  width?: number
}

const InputContainer = styled.div`
  &&&& {
    width: 100%;
    display: flex;
    .input-container {
      width: 100%;
      .input {
        min-height: 100%;
        height: 100%;
      }
      label {
        margin: 0;
      }
      input {
        min-height: 100%;
        border-right: 0;
        border-radius: 0.28571429rem 0 0 0.28571429rem;
      }
    }
    .select-container.field {
      width: auto !important;
    }
    .field {
      margin: 0 !important;
    }
    .field > .selection.dropdown {
      background-color: #e6e8eb;
      min-width: 100%;
      border-radius: 0 0.28571429rem 0.28571429rem 0;

      i::before {
        color: #000;
      }
    }
    .error-message-container {
      margin-top: -0.5em;
    }
  }
`

const InputWithSelect = ({
  error,
  input,
  label,
  labelText,
  defaultValue,
  select,
  style,
  touched,

  width,
  ...rest
}: InputWithSelectProps) => {
  if (!select) {
    return null
  }

  return (
    <>
      <label style={{ fontWeight: 700 }}>{label}</label>
      <InputContainer>
        <Form.Field className="input-container" style={style?.input}>
          <Form.Input
            type="number"
            value={input.value.input}
            min={0}
            onChange={(e, data) => {
              input.onChange({ input: data.value, select: input.value.select })
            }}
            {...rest}
            error={!!(touched && error)}
          />
          {touched && error && error.length && <ErrorLabel error={error} />}
        </Form.Field>
        <Form.Field className="select-container" style={select?.style}>
          <Form.Select
            defaultValue={input.value.select}
            onChange={(e, data) => {
              input.onChange({
                input: input.value.input,
                select: data.value,
              })
            }}
            options={select.options}
            {...select}
          />
        </Form.Field>
      </InputContainer>
    </>
  )
}

export default InputWithSelect
